import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { RegistrationEmail } from 'cpnl-common';
import { fetchRegistrationEmail } from './RegistrationEmailSlice';
import { RegistrationEmailContentSelector } from './RegistrationEmailContentSelector';

export function useRegistrationEmail(): AbstractContentState<RegistrationEmail> {
    return useCmsContent(fetchRegistrationEmail, RegistrationEmailContentSelector);
}
